<tilby-dialog-toolbar
    [hideConfirm]="true"
    [title]="title"
></tilby-dialog-toolbar>
<tilby-dialog-content>
    <mat-selection-list #list [multiple]="false" [hideSingleSelectionIndicator]="!data.showCheckbox" (selectionChange)="selectionHandler($event)">
        @for(item of data.list; track item){
            <mat-list-option [togglePosition]="'before'" [selected]="!!item.isSelected" [value]="item">
                <div matListItemTitle class="tw-flex">
                    @if(item.preIcon) {
                        <mat-icon [fontIcon]="item.preIcon" class="tw-pl-1"/>
                    }
                    <div class="tw-pl-2">{{ item.noTranslate ? item.name : (item.name | translate) }}</div>
                </div>
            </mat-list-option>
            <mat-divider></mat-divider>
        }
    </mat-selection-list>
</tilby-dialog-content>
